import { IconButton, Tooltip } from '@mui/material';
import LightModeIcon from '@mui/icons-material/LightMode';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import SettingsBrightnessIcon from '@mui/icons-material/SettingsBrightness';
import { useThemeChoice } from '@/theme/ThemeContext';

const LABELS: Record<ReturnType<typeof useThemeChoice>['choice'], string> = {
  auto: 'Theme: system (click to switch to light)',
  light: 'Theme: light (click to switch to dark)',
  dark: 'Theme: dark (click to switch to system)',
};

export function ThemeToggle() {
  const { choice, cycle } = useThemeChoice();
  const Icon = choice === 'light' ? LightModeIcon : choice === 'dark' ? DarkModeIcon : SettingsBrightnessIcon;
  return (
    <Tooltip title={LABELS[choice]}>
      <IconButton onClick={cycle} aria-label={LABELS[choice]} size="medium">
        <Icon />
      </IconButton>
    </Tooltip>
  );
}
